export default __webpack_public_path__ + "static/tetris-preview-b83613c02bff391acad3595730b7d8f8.png";